import { withBasePath } from '@/utils/basePath';

let refreshing = false;
export function registerSW() {
  if ('serviceWorker' in navigator) {
    // Register the service worker
    navigator.serviceWorker.register(withBasePath('/service-worker.js')).then((reg) => {
      console.log('Service worker registered successfully');

      // Check for updates when the user navigates to the page
      reg.update();

      // Handle updates manually instead of automatic skipWaiting
      if (reg.waiting) {
        // We have an update ready, but we'll let the user decide when to apply it
        console.log('New version available but waiting');
        // Optional: Show an update notification to the user
        try {
          window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { registration: reg } }));
        } catch (e) {
          console.warn('Failed to notify app about SW update availability', e);
        }
      }

      // Check if a new service worker is installing
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        console.log('New service worker installing');

        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            // When the new service worker is installed (but not activated yet)
            if (newWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                console.log('New version available but not activating automatically');
                // Optional: Show an update notification to the user
                try {
                  window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { registration: reg } }));
                } catch (e) {
                  console.warn('Failed to notify app about SW update availability', e);
                }
              } else {
                // First time install
                console.log('Service Worker installed for the first time');
              }
            }
          });
        }
      });
    }).catch(err => {
      console.error('Service worker registration failed:', err);
    });

    // Only reload the page once if the controller changes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        console.log('Service worker controller changed, reloading once');
        window.location.reload();
      }
    });
  }
}
